import React, { useState } from "react";
import { Stack, Typography } from "@mui/material";

import { HubButtonGroupSlider } from "../../components";

import SettingsTab from "./tabs/SettingsTab";
import HistoryTab from "./tabs/HistoryTab";
import CommentsTab from "./tabs/CommentsTab";

const tabs = [
  { id: 1, label: "Settings", Component: SettingsTab },
  { id: 2, label: "History", Component: HistoryTab },
  { id: 3, label: "Comments", Component: CommentsTab },
];

const QuoteBuilderForm = ({ quoteId, currentUserId }) => {
  const [tab, setTab] = useState(1);

  const ActiveTab = tabs.find((t) => t.id === tab)?.Component;

  return (
    <Stack
      gap="25px"
      sx={{
        overflow: "hidden",
        // Fill the sidebar so the active tab has a bounded height to scroll within
        height: "100%",
        minHeight: 0,
      }}
    >
      <Stack gap="5px" sx={{ flexShrink: 0 }}>
        <Typography variant="boldCaptionL" sx={{ marginLeft: "4px" }}>
          Activity
        </Typography>
        <HubButtonGroupSlider
          buttons={tabs}
          selected={tab}
          setSelected={setTab}
          sx={{ width: "fit-content" }}
        />
      </Stack>

      {ActiveTab && (
        <ActiveTab quoteId={quoteId} currentUserId={currentUserId} />
      )}
    </Stack>
  );
};

export default QuoteBuilderForm;
